import styled, { css } from 'styled-components';

export const Layout = styled.div<{ isDragging?: boolean }>`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 12.5vh 1.4rem 15vh;

  ${p =>
    p.isDragging &&
    css`
      &,
      & * {
        cursor: grabbing;
      }
    `}
`;

export const Container = styled.div`
  position: relative;
  width: 90%;
  max-width: 340px;
  margin: 0 auto;
  text-align: center;
`;

export const Cta = styled.div`
  position: relative;
  margin-top: 3rem;
  > *:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 700px;
`;
